import React from 'react';
import styled from "@emotion/styled";
import { Link } from 'gatsby';
import { Rubric } from 'styles/typography';
import dimensions from 'styles/dimensions';
import colors from "styles/colors";
import Fade from "react-reveal/Fade";

const CardContainer = styled(Link)`
  span {
    & + * {
      margin-top: 0.4rem;
    }
  }

  h5 {
    transition: color 0.12s ease-in-out;
  }
  
  &:hover {
    h5 {
      color: ${colors.red500};
    }
    
    img {
      transform: scale(1.05);
    }
  }

  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    height: 100%;
  }
`;

const CardImage = styled.div`
  position: relative;
  width: 100%;
  user-select: none;
  pointer-events: none;
  overflow: hidden;
  
  &::after {
    content: '';
    display: block;
    padding-bottom: 66.6667%;
  }
  
  & + * {
    margin-top: 2.4rem;
  }
  
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease-in-out;
    transform-origin: center center;
  }
`;

const CardAuthor = styled.span`
  display: block;
  color: ${colors.teal200};
  font-size: 1.6rem;
  font-weight: 500;
  margin-top: 0.8rem;
`;

const CardContent = styled.div``;

const CardResource = ({ title, author, promoteAuthor, uid, image, topic, variant }) => {
  return (
    <Fade bottom distance='2.4rem'>
      <CardContainer
        className={`${variant ? `CardResource--${variant}` : ''}`}
        to={`/post/${uid}`}
      >
        {image && (
          <CardImage>
            <img
              src={image.url}
              alt={image.alt}
              loading="lazy"
            />
          </CardImage>
        )}

        <CardContent>
          {topic && <Rubric>{topic}</Rubric>}
          <h5>{title}</h5>
          {author && promoteAuthor && (
            <CardAuthor>by {author}</CardAuthor>
          )}
        </CardContent>
      </CardContainer>
    </Fade>
  );
};

export default CardResource;
